import React from "react";
import { useFormik } from "formik";
import { PersonAddFormValidation } from "./PersonAddFormValidation";
import PersonAddFormFields from "./PersonAddFormFields";
import { ErrorToast, SuccessToast } from "../../../hoc/ToastNotify/ToastNotify";
import { client } from "../../../service/ApolloClient/ApolloClient";
import errorValidationApollo from "../../../utility/Forms/errorValidationApollo";
import {
  Box,
  Button,
  ButtonGroup,
  Card,
  CardContent,
  Typography,
} from "@material-ui/core";
import {
  MUTATION_CREATE_USER,
  MUTATION_EDIT_USER,
} from "../../../service/ApolloClient/ApolloMutation";
import Wrapper from "../../../hoc/Wrapper/Wrapper";
import { PERSON_SELECT_ATTACHMENT } from "../../../containers/Person/PersonEditPage";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import DebitCreditAddModal from "../../../containers/DebitCredit/DebitCreditAddModal";

const validationSchema = PersonAddFormValidation;

const PersonAddForm = (props) => {
  const { isEdit, data, isModal, isAdmin } = props;
  const [loading, setLoading] = React.useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);

  let valueDefault = {
    id: "",
    name: "",
    lastname: "",
    guarantor_id: "",
    recommender_id: "",
    id_number: "",
    id_card_number: "",
    phone: [],
    mobile: [],
    email: "",
    credit: "",
    group_id: "",
    username: "",
    password: "",
    password_repeat: "",
    address: "",
    description: "",
    postal_code: "",
    job: "",
    birthday: null,
    place_of_issuance: "",
    father: "",
  };

  if (isEdit) {
    valueDefault = {
      ...valueDefault,
      ...props.data,
      phone: JSON.parse(props.data.phone),
      mobile: JSON.parse(props.data.mobile),
    };
  }

  const formikData = useFormik({
    initialValues: valueDefault,
    validationSchema: validationSchema,
    onSubmit: (values, actions) => {

      submitHandle(values);
    },
  });

  const submitHandle = (values) => {
    let newValue = values;
    newValue.credit = parseFloat(values.credit);
    setLoading(true);
    client
      .mutate({
        mutation: isEdit ? MUTATION_EDIT_USER : MUTATION_CREATE_USER,
        variables: {
          ...newValue,
          phone: JSON.stringify(newValue.phone),
          mobile: JSON.stringify(newValue.mobile),
        },
      })
      .then((result) => {
        let user = isEdit ? result.data.editUser : result.data.createUser;
        if (user === null) {
          ErrorToast("لطفا موارد مشخص شده را اصلاح بفرمایید");
          formikData.setErrors(
            errorValidationApollo({ title: "قادر به ثبت نمی باشد" }),
          );
        } else {
          SuccessToast("با موفقیت ثبت شد");

          if (isModal) {
            props.handleClose();
          } else {
            props.history.push("/person/edit/" + user.id);
          }
        }
        setLoading(false);
      })
      .catch((reason) => {
        ErrorToast("لطفا موارد مشخص شده را اصلاح بفرمایید");
        formikData.setErrors(errorValidationApollo(reason));
        setLoading(false);
      });

    setLoading(true);
  };

  React.useEffect((e) => {
    if (props.setOpenDebit) props.setOpenDebit(setModalOpen);
  }, []);

  let showDetail = (
    <Wrapper>
      <Box ml={2} display={"flex"}>
        {isModal ? null : (
          <Box flexGrow={1} ml={1}>
            <Typography variant={"h5"} align={"left"}>
              {isAdmin
                ? "افزودن مدیر"
                : isEdit
                  ? "ویرایش کاربر" + " " + data.id + "#"
                  : "افزودن کاربر"}
            </Typography>
          </Box>
        )}
        <Box style={{ textAlign: "left", float: "right" }} display={"flex"}>
          {isEdit ? (
            <Wrapper>
              <ButtonGroup style={{ float: "right" }}>
                <Button
                  color={"secondary"}
                  onClick={(e) => {
                    setModalOpen(true);
                  }}
                >
                  بدهی{" "}
                </Button>
                <Button
                  color={"secondary"}
                  onClick={(e) => {
                    props.handleSelectPage(PERSON_SELECT_ATTACHMENT);
                  }}
                >
                  ضمیمه ها
                </Button>
                <Button color={"secondary"}>
                  <Link to={"/cheque/user/" + data.id + "/" + data.fullname}>
                    چک ها
                  </Link>
                </Button>
                <Button color={"secondary"}>
                  <Link
                    to={"/car-contract/user/" + data.id + "/" + data.fullname}
                  >
                    معامله ماشین
                  </Link>
                </Button>
                <Button color={"secondary"}>
                  <Link
                    to={
                      "/cheque-contract/user/" + data.id + "/" + data.fullname
                    }
                  >
                    خرید دین
                  </Link>
                </Button>
              </ButtonGroup>
              <DebitCreditAddModal
                modalOpen={modalOpen}
                handleClose={(e) => {
                  setModalOpen(false);
                  props.handleReloadDebit();
                }}
                user={data}
              />
            </Wrapper>
          ) : null}
        </Box>
      </Box>
      <PersonAddFormFields
        {...formikData}
        isEdit={isEdit}
        isModal={isModal}
        loading={loading}
        isAdmin={isAdmin}
        setModalOpen={setModalOpen}
      />
    </Wrapper>
  );

  return isModal ? (
    showDetail
  ) : (
    <Box>
      <Card>
        <CardContent>{showDetail}</CardContent>
      </Card>
    </Box>
  );
};

export default withRouter(PersonAddForm);
